import React, { useEffect,  } from 'react'
import { Container,Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import useAuth from '../../context/auth/useAuth'
import { Link } from 'react-router-dom'
import Version from '../../version'

export default function Dashboard() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()

	useEffect(() => {
		if(client){

		}
	},[dispatch, t, client])

	return (
        <Container className='p-5'>
            <Row className='sd-row-dashboard'>
                <label className='sd-label-dashboard'>{t('admin.dashboard.welcome')}</label>
                <label className="sd-label-userdashboard colornaranja">{client?.firstname}</label>
            </Row>
            <Row className='my-5'>
                <Col xs={12} lg={3}>
                    <Link to="/admin/menusdashboard" className='btn btn-dashboard btn-dashboard-white d-flex flex-column'>
                        <i className="fas fa-utensils fa-2x"></i>
                        {t('admin.dashboard.menus')}
                    </Link>
                </Col>
                <Col xs={12} lg={3}>
                    <Link to="/admin/ordersdashboard" className='btn btn-dashboard btn-dashboard-white d-flex flex-column'>
                        <i className="fas fa-receipt fa-2x"></i>
                        {t('admin.dashboard.orders')}
                    </Link>
                </Col>
                <Col xs={12} lg={3}>
                    <Link to="/admin/users" className='btn btn-dashboard btn-dashboard-white d-flex flex-column'>
                        <i className="fas fa-users fa-2x"></i>
                        {t('admin.dashboard.users')}
                    </Link>
                </Col>
                <Col xs={12} lg={3}>
                    <Link to="/admin/restaurants" className='btn btn-dashboard btn-dashboard-white d-flex flex-column'>
                        <i className="fas fa-hotel fa-2x"></i>
                        {t('admin.dashboard.restaurants')}
                    </Link>
                </Col>
            </Row>
            <Row className='justify-content-center'>
                <Col xs={12} lg={4}>
                    <Link to="/admin/logs" className='btn btn-dashboard btn-dashboard-white d-flex flex-column'>
                        <i className="fas fa-list"></i>
                        {t('admin.dashboard.logs')}
                    </Link>
                </Col>
            </Row>
            <Row>
                <Col className='d-flex justify-content-center'>
                    <Version/>
                </Col>
            </Row>
        </Container>
	)
}